








  import { Component, Vue, Prop } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'
  import { Stocks, CMS } from '@one/types'

  import MobileMenu from './OneNewMobileMenuTypes'
  import OneMobileWarehouseSelector from '~/components/molecules/menus/OneMobileWarehouseSelector.vue'
  import Warehouse = Stocks.Warehouse
  import GridElement = CMS.Grid.GridElement
  import GridContainer = CMS.Grid.GridContainer
  const categories = namespace('categories')
  const layout = namespace('layout')
  const cms = namespace('cms')
  const stocks = namespace('stocks')
  const account = namespace('account')

  interface GridLinkComponent extends GridElement {
    label: string
    link: string
    showOnMobile?: boolean
  }

  @Component({
    components: {
      OneNewMobileMenu: () => import('~/components/molecules/menus/OneNewMobileMenu.vue'),
    },
  })
  export default class OneMobileMenuWrapper extends Vue {
    @cms.Getter configuration: any
    @categories.Getter mainCategories: any
    @categories.State categories: any
    @layout.Mutation('TOGGLE_MOBILE_MENU') menuMobileShow: any
    @stocks.Getter getWarehouse: any
    @stocks.Getter getDefaultWarehouse: any
    @account.Getter getAdditionalWarehousesIds: any
    @account.Getter warehouseSelectionBlocked: any
    @account.Getter getAllWarehouses: any
    @stocks.State(state => state.warehouses.byId) warehousesMap: any
    @stocks.Mutation('SET_DEFAULT_WAREHOUSE') setDefaultWarehouse: any

    name: string = 'one-mobile-menu'

    @Prop({
      type: Boolean,
    })
    isActiveMenu?: boolean

    @Prop({
      type: Boolean,
      default: false,
    })
    hideCategories?: boolean

    get menuModel(): MobileMenu.MobileMenuModel {
      return {
        name: 'Menu',
        children: [
          {
            name: this.$t('header.categories') as string,
            children: this.mainCategoriesObjects,
          },
          {
            name: this.officeText,
            children: this.warehousesModel,
            specialClass: 'one-new-mobile-menu-item-warehouse-select',
          },
          ...this.mobileLinks.map((link: GridLinkComponent) => {
            return {
              name: link.label,
              link: link.link,
            }
          }),
        ],
      }
    }

    get mobileLinks(): Array<GridLinkComponent> {
      const isGridContainer = (element: GridElement): element is GridContainer => {
        return element.type === 'container'
      }
      const isGridLinkComponent = (element: GridElement): element is GridLinkComponent => {
        return element.type === 'link'
      }
      const findAllLinkComponents = (
        element: GridContainer,
      ): GridLinkComponent | Array<GridLinkComponent> => {
        const parseGridElement = (
          item: GridElement,
        ): GridLinkComponent | Array<GridLinkComponent> => {
          if (isGridContainer(item)) {
            return item.elements.map(parseGridElement).flat()
          }
          if (isGridLinkComponent(item)) {
            return item.showOnMobile ? item : []
          }
          return []
        }
        return parseGridElement(element)
      }
      const headerLinks: GridLinkComponent | Array<GridLinkComponent> = findAllLinkComponents(
        this.configuration.header,
      )
      return Array.isArray(headerLinks) ? headerLinks : [headerLinks]
    }

    get mainCategoriesObjects() {
      return this.mainCategories.map((category: any) => this.categories[category])
    }

    get disableWarehouseChange() {
      return this.warehouseSelectionBlocked && !this.getAdditionalWarehousesIds.length
    }

    get officeText() {
      if (this.getDefaultWarehouse) {
        return `<small>${this.$t('header.selected_office')}:</small> ${
          this.getDefaultWarehouse.label
        }`
      }
      return this.$t('header.select_office') as string
    }

    getSelectedWarehouseAddressString(id: string) {
      const wh: Warehouse = this.getWarehouse(id)
      return wh.address && `${wh.address.city || wh.address.country}`
    }

    getSelectedWarehousePhone(id: string) {
      const wh: Warehouse = this.getWarehouse(id)
      return wh.address && wh.address.phone
    }

    mapWarehouses(warehouses: any) {
      return warehouses.map(
        ({ id, label }: any) =>
          ({
            name: label,
            children: [
              {
                name: label,
                customComponent: OneMobileWarehouseSelector,
                componentProps: {
                  id: id,
                  address: this.getSelectedWarehouseAddressString(id),
                  text: this.officeText,
                  phone: this.getSelectedWarehousePhone(id),
                  addressTranslation: this.$t('header.address') as string,
                  phoneTranslation: this.$t('header.phone') as string,
                  chooseTranslation: this.$t('header.choose_office') as string,
                  onSelect: () => this.setWarehouse(id),
                  disabled: this.disableWarehouseChange,
                },
              },
            ],
            isWarehousesMenu: true,
          } as MobileMenu.MobileMenuItem),
      )
    }

    get warehousesModel(): Array<MobileMenu.MobileMenuItem> {
      if (!this.warehouseSelectionBlocked) {
        return this.mapWarehouses(Object.values(this.warehousesMap))
      } else {
        const result = Object.values(this.warehousesMap).filter(({ id }: any) =>
          this.getAllWarehouses.includes(id),
        )
        return this.mapWarehouses(result)
      }
    }

    async setWarehouse(id: string) {
      if (this.disableWarehouseChange) {
        return
      }
      this.closeMenuMobile()
      await this.$orderpath.cart.setWarehouseContext(id)
      this.setDefaultWarehouse(id)
    }

    closeMenuMobile() {
      this.menuMobileShow(false)
      this.$emit('close')
    }
  }
